import React from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { FaInstagram, FaWhatsapp, FaEnvelope, FaMapMarkerAlt, FaPhone } from 'react-icons/fa';
import '../main/footer.scss';

const Footer = () => {
  return (
    <footer className="footer" dir="rtl">
      <Container>
        <Row className="gy-5">
          {/* About Column */}
          <Col lg={4} md={12}>
            <div className="footer__section">
              <h4 className="footer__title">دکتر ابوالفضل خان‌بیکی</h4>
              <p className="footer__description">
                دکترای روان‌شناسی سلامت از اسپانیا، مدرس دانشگاه و موسس کلینیک روان‌شناسی اوج.
                با بیش از ۱۵ سال تجربه در زمینه زوج‌درمانی، مشاوره فردی و ارتقای مهارت‌های زندگی.
                هدف ما افزایش کیفیت زندگی شماست.
              </p>
              <div className="footer__social">
                <a href="https://instagram.com/khanbeiki_abolfazl" target="_blank" rel="noreferrer" aria-label="Instagram">
                  <FaInstagram />
                </a>
                <a href="https://wa.me/989304521003" target="_blank" rel="noreferrer" aria-label="WhatsApp">
                  <FaWhatsapp />
                </a>
                <a href="mailto:ravanara2013@gmail.com" aria-label="Email">
                  <FaEnvelope />
                </a>
              </div>
            </div>
          </Col>

          {/* Quick Links Column */}
          <Col lg={2} md={6} xs={6}>
            <div className="footer__section">
              <h4 className="footer__title">دسترسی سریع</h4>
              <ul className="footer__links">
                <li><a href="/">صفحه اصلی</a></li>
                <li><a href="/#about">درباره دکتر</a></li>
                <li><a href="/#services">خدمات مشاوره</a></li>
                <li><a href="/store">فروشگاه کتاب</a></li>
                <li><a href="/appointment-booking">رزرو وقت</a></li>
              </ul>
            </div>
          </Col>

          {/* Services Column */}
          <Col lg={2} md={6} xs={6}>
            <div className="footer__section">
              <h4 className="footer__title">خدمات تخصصی</h4>
              <ul className="footer__links">
                <li><a href="/#services">زوج‌درمانی</a></li>
                <li><a href="/#services">مشاوره فردی</a></li>
                <li><a href="/#services">مشاوره پیش از ازدواج</a></li>
                <li><a href="/#services">درمان اضطراب و افسردگی</a></li>
                <li><a href="/#services">رویکرد CBT</a></li>
              </ul>
            </div>
          </Col>

          {/* Contact Column */}
          <Col lg={4} md={12}>
            <div className="footer__section">
              <h4 className="footer__title">اطلاعات تماس</h4>
              <div className="footer__contact">
                <p>
                  <FaPhone />
                  <span>شماره تماس کلینیک: ۰۹۳۰۴۵۲۱۰۰۳</span>
                </p>
                <p>
                  <FaWhatsapp />
                  <span>مشاوره واتساپ: ۰۹۳۰۴۵۲۱۰۰۳</span>
                </p>
                <p>
                  <FaEnvelope />
                  <span>ایمیل: ravanara2013@gmail.com</span>
                </p>
                <p>
                  <FaMapMarkerAlt />
                  <span>آدرس: تهران (جهت دریافت آدرس دقیق کلینیک تماس بگیرید)</span>
                </p>
              </div>
            </div>
          </Col>
        </Row>

        <div className="footer__copyright">
          <p>&copy; {new Date().getFullYear()} وب‌سایت رسمی دکتر ابوالفضل خان‌بیکی. تمامی حقوق محفوظ است.</p>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
